import { InvisibleObserver } from './InvisibleObserver';
import { JioTranslatePlugin } from '@jiotranslate/core-beta';
import { TextObserver } from './TextObserver';

export const ObserverPlugin =
  (): JioTranslatePlugin => (jioTranslate, tools) => {
    if (jioTranslate.getInitialOptions().observerType === 'text') {
      tools.setObserver(TextObserver(jioTranslate.getInitialOptions()));
    } else {
      tools.setObserver(InvisibleObserver());
    }
    return jioTranslate;
  };
